// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceUsageResponse
 */
export interface SourceUsageResponse {
    /**
     * 
     * @type {string}
     * @memberof SourceUsageResponse
     */
    docTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SourceUsageResponse
     */
    sourceType: string;
    /**
     * 
     * @type {string}
     * @memberof SourceUsageResponse
     */
    scrapingSource: string;
    /**
     * 
     * @type {string}
     * @memberof SourceUsageResponse
     */
    docUrl: string;
    /**
     * 
     * @type {number}
     * @memberof SourceUsageResponse
     */
    citations: number;
    /**
     * 
     * @type {boolean}
     * @memberof SourceUsageResponse
     */
    used: boolean;
}

/**
 * Check if a given object implements the SourceUsageResponse interface.
 */
export function instanceOfSourceUsageResponse(value: object): value is SourceUsageResponse {
    if (!('docTitle' in value) || value['docTitle'] === undefined) return false;
    if (!('sourceType' in value) || value['sourceType'] === undefined) return false;
    if (!('scrapingSource' in value) || value['scrapingSource'] === undefined) return false;
    if (!('docUrl' in value) || value['docUrl'] === undefined) return false;
    if (!('citations' in value) || value['citations'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    return true;
}

export function SourceUsageResponseFromJSON(json: any): SourceUsageResponse {
    return SourceUsageResponseFromJSONTyped(json, false);
}

export function SourceUsageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceUsageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'docTitle': json['doc_title'],
        'sourceType': json['source_type'],
        'scrapingSource': json['scraping_source'],
        'docUrl': json['doc_url'],
        'citations': json['citations'],
        'used': json['used'],
    };
}

export function SourceUsageResponseToJSON(json: any): SourceUsageResponse {
    return SourceUsageResponseToJSONTyped(json, false);
}

export function SourceUsageResponseToJSONTyped(value?: SourceUsageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'doc_title': value['docTitle'],
        'source_type': value['sourceType'],
        'scraping_source': value['scrapingSource'],
        'doc_url': value['docUrl'],
        'citations': value['citations'],
        'used': value['used'],
    };
}

